// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.supportContact__vX5b4 {
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
  padding: 25px;
  display: flex;
  gap: 20px;
  text-decoration: none;
}
@media (max-width: 800px) {
  .supportContact__vX5b4 {
    padding: 15px;
  }
}

.contactPhoto__GE6eB {
  width: 50%;
  max-width: 120px;
  max-height: 120px;
  aspect-ratio: 1/1;
  object-fit: cover;
}

.contactTitle__erq15 {
  display: flex;
  width: 100%;
}

.contactNameWrapper__yOezi {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contactName__7RwgZ {
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
}

.contactRole__SlYic {
  color: var(--tables-primary-row-text-additional);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./../src/pages/HelpAndResources/components/TeamMemberCard/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,qDAAA;EACA,sCAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;EACA,qBAAA;AAzEF;AA2EE;EARF;IASI,aAAA;EAxEF;AACF;;AA2EA;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,WAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxEF;;AA2EA;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAxEF;;AA2EA;EACE,gDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.supportContact {\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n  padding: 25px;\n  display: flex;\n  gap: 20px;\n  text-decoration: none;\n\n  @media (max-width: 800px) {\n    padding: 15px;\n  }\n}\n\n.contactPhoto {\n  width: 50%;\n  max-width: 120px;\n  max-height: 120px;\n  aspect-ratio: 1 / 1;\n  object-fit: cover;\n}\n\n.contactTitle {\n  display: flex;\n  width: 100%;\n}\n\n.contactNameWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.contactName {\n  color: var(--tables-primary-row-text-main);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.contactRole {\n  color: var(--tables-primary-row-text-additional);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"supportContact": `supportContact__vX5b4`,
	"contactPhoto": `contactPhoto__GE6eB`,
	"contactTitle": `contactTitle__erq15`,
	"contactNameWrapper": `contactNameWrapper__yOezi`,
	"contactName": `contactName__7RwgZ`,
	"contactRole": `contactRole__SlYic`
};
module.exports = ___CSS_LOADER_EXPORT___;
